export const POSTED_PERIOD_ALL = "__all";
export const POSTED_PERIOD_LAST_24H = "last_24h";
export const POSTED_PERIOD_LAST_WEEK = "last_week";
export const POSTED_PERIOD_LAST_MONTH = "last_month";
export const RADIUS_ALL = "__all";
export const RADIUS_OPTIONS = [5, 10, 20, 50];
export const MIN_RATING_ALL = "__all";
export const MIN_RATING_OPTIONS = ["1", "2", "3", "4", "5"];
